type GlobalSearchProps = {
  search?: string
  searchIn?: string[]
}

export function buildFilter<T>(FilterClass: new (data: Partial<T>) => T, defaultFilter: T, globalSearch?: GlobalSearchProps): T[] {
  if (!globalSearch?.search || !globalSearch.searchIn?.length) return [defaultFilter]

  return globalSearch.searchIn.map(
    (key) =>
      new FilterClass({
        ...defaultFilter,
        [key]: `%${globalSearch.search}%`,
      }),
  )
}
